<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="900px" dark>
      <template v-slot:activator="{ on }">
        <v-btn color="yellow" outlined rounded @click="testPDF" v-on="on"
          >CREATE DOC TEST</v-btn
        >
      </template>
      <v-card
        style="border-radius: 26px; border: 3px solid black; height: 800px"
      >
        <v-card-title>
          <span class="headline">TEST DOC</span>
        </v-card-title>
        <div class="ma-auto">
          <v-card>
            <v-form>
              <v-text-field
                class="ma-auto"
                label="Who Is Being Deposed?"
                color="yellow lighten-2"
                style="max-width: 500px"
                v-model="deponent"
              ></v-text-field>
            </v-form>
            <VueSignaturePad
              width="500px"
              height="200px"
              ref="signaturePad"
              style="border: 1px solid blue; background-color: white"
              class="ma-auto"
            />
            <v-card-actions class="ma-auto">
              <v-spacer></v-spacer>
              <v-btn @click="save">Save</v-btn>
              <v-btn @click="undo">Undo</v-btn>
              <v-btn @click="testPDF">Apply</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </div>
        <iframe
          :src="iframeSrc"
          frameborder="0"
          style="width: 100%; height: 100%"
          class="ma-auto"
        ></iframe>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
// import * as firebase from "firebase";
import VueSignaturePad from "vue-signature-pad";

import * as moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// import { parse } from "path";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  // props: ["matter", "user", "plaintiff"],
  props: ["matter", "user", "plaintiff"],
  components: {
    VueSignaturePad
  },

  data() {
    return {
      signature: null,
      deponent: null,
      dialog: false,
      iframeSrc: null
      // content: `THE DEPOSITION OF ${
      //   this.deponent
      // } Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?`
    };
  },
  computed: {
    firm() {
      return this.$store.getters.firm;
    },
    // user() {
    //   return this.$store.getters.user;
    // },
    plaintiffString() {
      let tempPlaintiffString = ``;
      this.matter.plaintiffs.forEach(plaintiff => {
        tempPlaintiffString += ` ${plaintiff.fullName.toUpperCase()};`;
      });
      return tempPlaintiffString;
    },
    defendantString() {
      let tempDefendantString = ``;
      this.matter.defendants.forEach(defendant => {
        tempDefendantString += ` ${defendant.fullName.toUpperCase()};`;
      });
      return (tempDefendantString += ` DOES 1 THROUGH 50, INCLUSIVE,`);
    }
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // this.signature = this.$refs.signaturePad.toDataURL(data);
      this.signature = data;

      console.log(isEmpty);
      console.log(data);
    },
    testPDF() {
      pdfMake.fonts = {
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf"
        },

        Amiri: {
          normal: "Amiri-Regular.ttf",
          bold: "Amiri-Bold.ttf",
          italics: "Amiri-Italic.ttf",
          bolditalics: "Amiri-BoldItalic.ttf"
        }
      };
      // let plaintiffFullName = this.plaintff.fullName;
      console.log("this.plaintiff", this.plaintiff);
      let content = `THE DEPOSITION OF ${this.deponent} Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?`;
      let docDef = {
        // ...
        background: () => {
          return [
            {
              style: "tableExample",
              table: {
                widths: [72, "*", 36],
                body: [
                  [
                    {
                      text: "",
                      border: [false],
                      margin: [0, 72, 0, 0]
                    },
                    {
                      text: "",
                      border: [true, false, true, false]
                    },
                    {
                      text: "",
                      border: [false]
                    }
                  ],
                  [
                    {
                      stack: [
                        { text: "1" },
                        { text: "2" },
                        { text: "3" },
                        { text: "4" },
                        { text: "5" },
                        { text: "6" },
                        { text: "7" },
                        { text: "8" },
                        { text: "9" },
                        { text: "10" },
                        { text: "11" },
                        { text: "12" },
                        { text: "13" },
                        { text: "14" },
                        { text: "15" },
                        { text: "16" },
                        { text: "17" },
                        { text: "18" },
                        { text: "19" },
                        { text: "20" },
                        { text: "21" },
                        { text: "22" },
                        { text: "23" },
                        { text: "24" },
                        { text: "25" },
                        { text: "26" },
                        { text: "27" },
                        { text: "28" }
                      ],
                      alignment: "right",
                      lineHeight: 1.15,
                      border: [false, false, true, false],
                      margin: []
                    }, //END BACKGROUND STACK OBJECT
                    [
                      {
                        text: ""
                      }
                    ],
                    {
                      text: [" "],
                      border: [true, false, false, false]
                    }
                  ]
                ] //END BACKGROUND BODY ARRAY
              },
              layout: { defaultBorder: false } //END BACKGROUND TABLE OBJECT
            } //END BACKGROUND OBJECT
          ]; //END BACKGROUND RETURN ARRAY
        }, //END BACKGROUND

        //BEGIN FOOTER
        // footer: function(currentPage, pageCount){
        footer: function(currentPage) {
          return [
            {
              table: {
                widths: [72, "*", 36],
                // heights: [72,72,72],
                body: [
                  [
                    {
                      text: "",
                      border: [false, false, true, false]
                    },
                    {
                      stack: [
                        //TESTING TO SELECT PLAINTIFF
                        // {text: `${matter.plaintiffs[0].fullName.toUpperCase()}'S --document title --`, alignment: 'center', fontSize: 12},
                        // {text: `${finalDocument.questions[0].response}`, alignment: 'center', fontSize: 8},
                        // {
                        //   text: `${this.plaintiff.fullName}`,
                        //   alignment: "center",
                        //   fontSize: 8
                        // },
                        {
                          text: `SOME PLAINTIFF`,
                          alignment: "center",
                          fontSize: 8
                        },
                        {
                          text: `${currentPage.toString()}`,
                          alignment: "center",
                          fontSize: 9
                        }
                      ],
                      layout: { defaultBorder: false },
                      border: [false, true, false, false]
                    },
                    { text: "", border: [true, false, false, false] }
                  ]
                ]
              }
            }
          ];
        },
        //end footer
        // userPassword: '123',
        content: [
          // AUTHOR STACK
          {
            stack: [
              // {text: `${selectedPlaintiff.attorney.name} (SBN:######)`, margin: [44,40,0,0], },
              // {text: `${authors[0].attorneyName} (SBN: ${authors[0].attorneyBar})`, lineHeight: 1},
              // { text: `Johnny Law (SBN: 123456)`, lineHeight: 1 },
              { text: `Johnny Law (SBN: 123456)`, lineHeight: 0.7 },
              // {text: `${authors[0].attorneyEmail}`, lineHeight: 1},
              { text: `${this.user.email}`, lineHeight: 0.7 },
              // {text: `Some Dude (SBN:######)`, lineHeight: 1},
              // {text: `somedudesemail@email.com`, lineHeight: 1},
              { text: `${this.firm.firmName.toUpperCase()}`, lineHeight: 0.7 },
              { text: `${this.firm.firmAddressLine}`, lineHeight: 0.7 },
              // {text: `${authors[0].attorneyCity}, ${authors[0].attorneyState} ${authors[0].attorneyZip || `ZIPPY`}`, lineHeight: 1},
              { text: `${this.firm.firmCityStateZip}`, lineHeight: 0.7 },
              { text: `${this.firm.firmPhone}`, lineHeight: 0.7 },
              { text: " ", lineHeight: 1 },
              { text: `Attorney for:  ${this.plaintiff.fullName}` }
              // {text: ` `},
            ],
            margin: [44, 2, 7, 0],
            lineHeight: 0,
            fontSize: 12
          },
          //JURISDICTION STACK
          {
            stack: [
              {
                text: `SUPERIOR COURT OF THE STATE OF CALIFORNIA`,
                margin: [0, 38, 0, 0]
              },
              // {
              //   text: `FOR THE COUNTY OF ${this.matter.jdxCounty.toUpperCase() ||
              //     "null"}`
              // }
              {
                text: `FOR THE COUNTY OF ${this.matter.jdxCounty || "null"}`
              }
            ],
            fontSize: 12,
            alignment: "center",
            lineHeight: 1,
            bold: true
          },
          //END JURISDICTION STACK

          //BEGIN CAPTION STACK
          {
            stack: [
              { text: ` ` },
              {
                table: {
                  widths: ["*", "*"],
                  heights: [144],
                  body: [
                    [
                      //PARTIES
                      {
                        stack: [
                          //PLAINTIFFS
                          {
                            text: `${this.plaintiffString}`,
                            margin: [0, 4, 0, 0]
                          },
                          {
                            text: `Plaintiff(s),`,
                            margin: [0, 4, 4, 0],
                            alignment: "right"
                          },

                          { text: "v.", alignment: "center", lineHeight: 1.5 },

                          //DEFENDANTS
                          { text: `${this.defendantString}` },
                          {
                            text: `Defendant(s),`,
                            margin: [0, 4, 4, 0],
                            alignment: "right"
                          }
                        ],
                        border: [false, false, true, true],
                        alignment: "justify",
                        heights: ["*"]
                      },
                      // DOCUMENT TITLE
                      {
                        stack: [
                          {
                            text: `CASE NO. ${this.matter.caseNumber ||
                              "**missing case number in data**"}`
                          },
                          {
                            text: `Assigned to ${this.matter.jdxJudge ||
                              ``}, Dept. ${this.matter.jdxDepartment || "none"}`
                          },
                          { text: ` ` },
                          // {text:`${selectedPlaintiff.fullName.toUpperCase()}'S RESPONSE TO FORM INTERROGATORIES, SET NO. ONE`, bold: true},

                          // {text:`${finalDocument.questions[0].response.toUpperCase()}`, bold: true},
                          { text: `TEST DOCUMENT`, bold: true },

                          { text: ` ` },
                          { text: ` ` },
                          { text: `Complaint filed: ##todo` },
                          { text: `Trial Date: ##todo` }
                        ],
                        border: [false, false, false, false],
                        alignment: "justify"
                      }
                    ]
                  ],
                  fontSize: 12
                }
              }
            ],
            margin: [44, 0, 0, 0]
          },
          //END CAPTION

          //BEGIN BODY STACK
          {
            stack: [
              //lorem ipsum
              {
                text: ` TO ALL PARTIES AND THEIR ATTORNEYS OF RECORD : \n 			${content}`,
                alignment: "justify",
                margin: [0, 4, 0, 0],
                preserveLeadingSpaces: true
              },
              {
                table: {
                  widths: ["*", "*"],
                  body: [
                    [
                      {
                        text: `DATED: ${moment().format("LL")}`,
                        border: [false, false, false, false]
                      },
                      // {text: `${authors[0].attorneyFirmName.toUpperCase()}`, alignment: 'center', border: [false, false, false, false],}
                      {
                        text: `${this.firm.firmName.toUpperCase()}`,
                        alignment: "center",
                        border: [false, false, false, false]
                      }
                    ]
                  ],
                  fontSize: 12
                }
              },
              {
                table: {
                  widths: ["*", "*"],
                  // heights:[100],
                  body: [
                    [
                      { text: ` `, border: [false, false, false, false] },
                      // {text: `\n\nBy:       /s/${authors[0].attorneyName.toUpperCase()}/s/`, alignment: 'left', border: [false, false, false, true],}
                      // {
                      //   text: `\n\nBy:       /s/JOHNNY LAW/s/`,
                      //   alignment: "left",
                      //   border: [false, false, false, true]
                      // }
                      {
                        image: this.signature,
                        width: 150,
                        height: 60,
                        alignment: "center",
                        border: [false, false, false, true]
                      }
                    ],

                    [
                      { text: ` `, border: [false, false, false, false] },
                      {
                        // text: `${authors[0].attorneyName.toUpperCase()}`, alignment: 'right'
                        text: `JOHNNY LAW`,
                        alignment: "center",
                        border: [false, false, false, false]
                      }
                    ]
                  ],
                  fontSize: 12
                }
              },
              // {
              //   // text: `${authors[0].attorneyName.toUpperCase()}`, alignment: 'right'
              //   text: `JOHNNY LAW`,
              //   alignment: ""
              // },
              // PROOF OF SERVICE STACK
              {
                stack: [
                  {
                    text: `PROOF OF SERVICE`,
                    alignment: "center",
                    bold: true,
                    pageBreak: "before",
                    margin: [0, 0, 0, 0]
                  },
                  { text: " " },
                  {
                    text: `STATE OF CALIFORNIA             )`,
                    alignment: "left"
                  },
                  {
                    text: `                                                ) ss.`,
                    alignment: "left",
                    preserveLeadingSpaces: true
                  },
                  {
                    text: `COUNTY OF LOS ANGELES      )`,
                    alignment: "left"
                  },
                  {
                    text: ` `
                  },
                  {
                    text: ` I am employed in the County of Los Angeles, State of California.  I am over the age of 18 and not a party to the within action; my business address is TAPLAW HEAD QUERTERS, LOS ANGELES CALIFORNIA. On ____________________, I served the foregoing document described as ###TEST DOC##### has been served on the interested party(ies) in this action as follows:`,
                    alignment: "justify"
                  },
                  { text: ` ` },
                  {
                    stack: [
                      {
                        table: {
                          widths: [10, "*"],
                          body: [
                            [
                              {
                                text: `${this.byMail || ""}`
                              },
                              {
                                text: `(BY MAIL) TAPLAW has deposited such envelope in the mail at TAPLAW HEADQUARTERS. The envelope was mailed with postage thereon fully prepaid. I am readily familiar with TAPLAW's practice of collection and processing of correspondence for mailing. It is deposited with the U.S. Postal Service on the same day in the ordinary course of business. I am aware that on motion of the party served, service is presumed invalid if postal cancellation date or postage meter date is more than 1 day after date of deposit for mailing in affidavit. (TO ALL NOTED ON SERVICE LIST)`,
                                // margin: [60, 0, 0, 0]
                                border: [true, true, true, false]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        table: {
                          widths: [10, "*"],
                          body: [
                            [
                              {
                                text: `${this.byPersonalService || ""}`,
                                border: [true, true, true, false]
                              },
                              {
                                text: `(BY PERSONAL SERVICE) TAPLAW caused such envelope to be delivered by hand to the addressee(s).`,
                                // margin: [60, 0, 0, 0]
                                border: [true, true, true, false]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        table: {
                          widths: [10, "*"],
                          body: [
                            [
                              {
                                text: `${this.byOvernightDelivery || ""}`,
                                border: [true, true, true, false]
                              },
                              {
                                text: `(BY OVERNIGHT DELIVERY) TAPLAW caused such envelope to be delivered by overnight delivery in a box regularly maintained by an overnight delivery service with delivery fees paid or provided for in accordance with ordinary business practices. (TO ALL NOTED ON SERVICE LIST)`,
                                // margin: [60, 0, 0, 0]
                                border: [true, true, true, false]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        table: {
                          widths: [10, "*"],
                          body: [
                            [
                              {
                                text: `${this.byEmail || ""}`,
                                border: [true, true, true, false]
                              },
                              {
                                text: `(BY EMAIL) Based on court order or an agreement of the parties to accept service by e-mail or electronic transmission, TAPLAW caused such documents to be sent to the persons at the email addressses listed in the attahced mailing list. TAPLAW has not received any electronic message or other indication that the transmission was unsuccessfull.(TO ALL NOTED ON SERVICE LIST)`,
                                // margin: [60, 0, 0, 0]
                                border: [true, true, true, false]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        table: {
                          widths: [10, "*"],
                          body: [
                            [
                              {
                                text: `X`,
                                border: [true, true, true, false]
                              },
                              {
                                text: `(STATE) I declare under penalty of perjury under the laws of the State of California that the above is true and correct.`,
                                // margin: [60, 0, 0, 0]
                                border: [true, true, true, false]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        table: {
                          widths: [10, "*"],
                          body: [
                            [
                              {
                                text: `    `
                              },
                              {
                                text: `(FEDERAL) I declare under penalty of perjury under the laws of the United States of America that the above is true and correct.`
                                // margin: [60, 0, 0, 0]
                              }
                            ]
                          ]
                        }
                      }
                    ]
                  }
                ],
                lineHeight: 0.7,
                alignment: "justify"
              }
            ],
            lineHeight: 1.15,
            fontSize: 12,
            margin: [44, 0, 0, 0]
          } //END BODY
        ],
        pageMargins: [42, 78, 55, 40], //END CONENT SACK

        //BEGIN BACKGROUND STYLES
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 0, 0, 0]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black"
          }
        },
        defaultStyle: {
          // alignment: 'justify',
          font: "Amiri"
        },
        pageSize: "LETTER"
      }; //END (dd) DOCUMENT DENFENITION

      let doc = pdfMake.createPdf(docDef);
      doc.getDataUrl(url => {
        this.iframeSrc = url;
      });

      //create a blob
      // doc.getBlob((blob)=> {
      // 	this.docBlob = blob
      // })
    }
  }
};
</script>
<style lang="scss" scoped></style>
